import { render, staticRenderFns } from "./SkinSearch.vue?vue&type=template&id=8fdd307a&"
import script from "./SkinSearch.vue?vue&type=script&lang=js&"
export * from "./SkinSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports